var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5996 8C14.5996 11.3137 11.9133 14 8.59961 14C5.2859 14 2.59961 11.3137 2.59961 8C2.59961 4.68629 5.2859 2 8.59961 2C11.9133 2 14.5996 4.68629 14.5996 8ZM13.4398 14.3702C12.0959 15.3929 10.4186 16 8.59961 16C4.18133 16 0.599609 12.4183 0.599609 8C0.599609 3.58172 4.18133 0 8.59961 0C13.0179 0 16.5996 3.58172 16.5996 8C16.5996 9.87602 15.9539 11.6012 14.8725 12.9654L19.3678 18.3598C19.7214 18.7841 19.6641 19.4147 19.2398 19.7682C18.8155 20.1218 18.185 20.0645 17.8314 19.6402L13.4398 14.3702Z",
    fill: "#9E9E9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.e320b1ab250a70d8360f7d0a7a2585e3.svg";
export { ForwardRef as ReactComponent };